import React, {useState} from "react";
import { Input } from '@material-ui/core';
import { Paper } from "@material-ui/core";
import * as S from '../formStyle';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import * as Style from '../styles'


function PercentBox({
    title,
    filterName,
    handleInputChange,
    valoresRespostas,
    decimalPlaces,
    zeroValue,
    isLoading,
    ordem,
    conteudoOnChange,
    disabledList,
    componenteWidth
}) {
  const classes = S.useStyles();

  return (
    <>
        <label className={classes.label}>{title}</label>
        <Paper className={classes.medium} style={{ 
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: '0px',
            width: `${componenteWidth}px`
        }} elevation={0}>
            <Style.PercentageDiv>
                <CurrencyTextField
                    value={valoresRespostas[ordem] !== zeroValue ? valoresRespostas[ordem]  : 0}
                    currencySymbol=""
                    placeholder={title}
                    decimalCharacter=","
                    minimumValue="0"
                    maximumValue="100"
                    decimalPlaces={decimalPlaces}
                    disabled={isLoading || disabledList[ordem]}
                    modifyValueOnWheel={false}
                    InputProps={{
                        className: classes.inputCurrency,
                    }}
                    digitGroupSeparator="."
                    name={filterName}
                    onBlur={(e) => {
                        handleInputChange(e, ordem, e.target.value, conteudoOnChange)
                    }}
                />
            <span className={classes.porcentage}>%</span>
            </Style.PercentageDiv>
        </Paper>
    </>
  );
}

export default PercentBox;
